import React from 'react';
import { Route, Routes } from 'react-router-dom';
import {
  HomeworkPreview,
  MODE,
} from '@grcs/views/shared/components/Homework/HomeworkPreview';
import { AdminUpdatePasswordPageEnhanced as AdminUpdatePasswordPage } from '@grcs/views/Admin/AdminUser/AdminUpdatePasswordPage.enhanced';
import { ClassDashboardEnhanced as ClassDashboard } from '@grcs/views/Class/ClassDashboard.enhanced';
import { ClassPublishHomeworkEnhanced as ClassPublishHomework } from '@grcs/views/Class/ClassPublishHomework.enhanced';
import { ClassStudentEnhanced as ClassStudent } from '@grcs/views/Class/ClassStudent.enhanced';
import { ClassStudentSelectionEnhanced as ClassStudentSelection } from '@grcs/views/Class/ClassStudentSelection.enhanced';
import { AnalyticsEnhanced as Analytics } from '@grcs/views/Teacher/Analytics.enhanced';
import { StudentAnalyticsTeacherPageEnhanced as StudentAnalyticsTeacherPage } from '@grcs/views/Teacher/StudentAnalyticsTeacherPage.enhanced';
import { TeacherEnhanced as Teacher } from '@grcs/views/Teacher/Teacher.enhanced';

export const TeacherRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Teacher from="home" />} />
      <Route path="/analytics" element={<Teacher from="analytics" />} />
      <Route
        path="/student-analytics"
        element={<StudentAnalyticsTeacherPage />}
      />
      <Route
        path=":year/class/:classId/home"
        element={<ClassDashboard from="home" />}
      />
      <Route
        path=":year/class/:classId/analytics"
        element={<ClassDashboard from="analytics" />}
      />

      <Route path=":year/class/:classId/student" element={<ClassStudent />} />
      <Route
        path=":year/class/:classId/student/add"
        element={<ClassStudentSelection />}
      />
      <Route
        path=":year/class/:classId/homeworks"
        element={<ClassPublishHomework />}
      />
      <Route
        path=":year/class/:classId/analytics/:homeworkId"
        element={<Analytics />}
      />
      <Route
        path="content/:contentId/view"
        element={<HomeworkPreview mode={MODE.PREVIEW} />}
      />
      <Route
        path=":year/class/:classId/content/:contentId/publish"
        element={<HomeworkPreview mode={MODE.PUBLISH} />}
      />
      <Route path="update-password" element={<AdminUpdatePasswordPage />} />
    </Routes>
  );
};
